import React, { Fragment } from "react";
import { Container, Row, Col, Card} from "react-bootstrap";
import { Link } from "react-router-dom";


const CaseStudies = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" >
        <h1>Creativity In Action: Stories of Success</h1>
        <p className="lead"> MindAntix partners with organizations and learning centers to build skills and culture for the future of work.</p>
      </div> 

      <Container fluid className="p-5">
         <Row className="mb-5">
            <h4> Here are a few success stories that illustrate our work: </h4>
         </Row>
         <Row>
         <Col className="col-12 col-md-6 mb-3">
               <Card className="border-info">
                  <Row>
                     <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center">
                        <img className="card-img-top img-fluid p-3"
                           src="/images/caseStudies/GenderBias.png"
                           height="100%"
                           width = "100%"
                           alt="Gender Bias"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title>
                              Impact of Gender Bias on Innovation
                           </Card.Title>
                           <Card.Text className="small">
                             MindAntix conducted a study to understand the impact of gender bias on innovation. The study uncovered four key factors that reduce innovation and offered actionable strategies for leaders. <Link to="/docs/caseStudies/GenderBias.pdf" target="_blank">Learn more &raquo;</Link> 
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>
                  
               </Card>
            </Col>
            <Col className="col-12 col-md-6 mb-3">
               <Card className="border-info">
                  <Row>
                     <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center">
                        <img className="card-img-top img-fluid p-3"
                           src="/images/caseStudies/PositiveAllyLogo.png"
                           height="100%"
                           width = "100%"
                           alt="Positive Ally"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title>
                              Life Skills for 21st Century Learner
                           </Card.Title>
                           <Card.Text className="small">
                             Positive Ally is an after-school program to develop leadership skills in K-5 students. MindAntix developed new courses to augment their curriculum while addressing their focus areas. <Link to="/docs/caseStudies/PositiveAlly21stCenturySkills.pdf" target="_blank">Learn more &raquo;</Link> 
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>
                  
               </Card>
            </Col>
         </Row>

         <Row>
            <Col className="col-12 col-md-6 mb-3">
               <Card className="border-info">
                  <Row>
                     <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center">
                        <img className="card-img-top img-fluid p-3"
                           src="/images/challenges/How To Be An Inventor-xs.png"
                           height= "100%"
                           width = "100%"
                           fluid = "true"
                           alt="Positive Ally"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title>
                              Parent Volunteers Bringing Creativity To Their School
                           </Card.Title>
                           <Card.Text className="small">
                           Parents from a progressive school in Israel, worked with their administration to bring MindAntix courses to their elementary classrooms. Parent volunteers translated the content and taught the program.<Link to="/docs/caseStudies/ParentLedCourses.pdf" target="_blank"> Learn more &raquo;</Link> 
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>
                  
               </Card>
            </Col>

            <Col className="col-12 col-md-6 mb-3">
               <Card className="border-info">
                  <Row>
                     <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center">
                        <img className="card-img-top img-fluid p-3"
                           src="/images/caseStudies/ArchimedesLogo.png"
                           height="100%"
                           width = "100%"
                           alt="Positive Ally"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title>
                           Nurturing Next Generation Innovators
                           </Card.Title>
                           <Card.Text className="small">
                           Each summer, Archimedes School and MindAntix offer summer camps to nurture next generation innovators. Students learn creativity techniques and 3D printing to bring their ideas to life. <Link to="/docs/caseStudies/ArchimedesInventorGrowth.pdf" target="_blank">Learn more &raquo;</Link> 
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>
                  
               </Card>
            </Col>
         </Row>

         <Row>

            <Col className="col-12 col-md-6 mb-3">
               <Card className="border-info">
                  <Row>
                     <Col className="col-12 col-md-4 d-flex align-items-center justify-content-center">
                        <img className="card-img-top img-fluid p-3"
                           src="/images/caseStudies/school.png"
                           height="100%"
                           width = "100%"
                           alt="Positive Ally"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title>
                              Be Our Next Success Story
                           </Card.Title>
                           <Card.Text className="small">
                              Interested in partnering with MindAntix to bolster your learning program with a variety of cognitive creativity techniques? Be our next success story! Send us an email at: hello@mindantix.com.
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>
                  
               </Card>
            </Col>
         </Row>


      </Container>

    </Fragment>
       
  );
};
  
export default CaseStudies;